// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__W4L1m","icon":"styles_icon__3jJxf"};